
const USER_KEY: string = 'user'
const URL_KEY: string = 'URL'
export  default  {
  saveUser(value: any ){
    localStorage.setItem(USER_KEY, JSON.stringify(value))
  },
  getUser(){
    const a: string | null = localStorage.getItem(USER_KEY);
    return  a && a!=='undefined' ? JSON.parse(a) : null
  },
  clear(){
    localStorage.clear()
  },
  saveURL(url: string[]){
    localStorage.setItem(URL_KEY, JSON.stringify(url))
  },
  getURL(){
    const a: string | null = localStorage.getItem(URL_KEY)
    localStorage.removeItem(URL_KEY)
    return  a && a!=='undefined' ? JSON.parse(a) : null
  }
}
